<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

onMounted(() => {
  if (typeof window === 'undefined') return
  window.location.assign(route.fullPath)
})
</script>
